export default __webpack_public_path__ + "static/header-90-years-logo-13439aff6b1c0bfa29ef514dc58fa2ba.png";